import React, { useEffect, useState } from 'react';
import GlobalLoader from '@/components/common/layout/GlobalLoader/GlobalLoader';
import WalletCard from '@/components/common/shared/WalletCard/WalletCard';
import useGetWallets from '@/components/wallets/list/walletList/useGetWallets';
import { MediaType } from '@/types/MediaType';
import { WalletCategory } from '@/types/Wallet';
import { LIST_DEFAULT_PAGE_SIZE } from '@/utils/defaults';
import styles from './WalletDashboard.module.css';

interface WalletDashboardProps {
  category: WalletCategory;
}

const WalletDashboard: React.FC<WalletDashboardProps> = ({ category }) => {
  const [withArchive, setWithArchive] = useState(false);
  const [globalFilter] = useState('');
  const [sorting] = useState([]);
  const [pagination] = useState({ pageIndex: 0, pageSize: LIST_DEFAULT_PAGE_SIZE });

  const { data, isLoading, isError } = useGetWallets({
    globalFilter,
    sorting,
    pagination,
  });

  const [filteredWallets, setFilteredWallets] = useState([]);

  useEffect(() => {
    if (!data?.content) return;
    const currentYear = new Date().getFullYear();
    const allWallets = data.content.filter(
      (wallet) => withArchive || Number(wallet.year) >= currentYear
    );

    const filteredByCategory =
      category === 'all'
        ? allWallets
        : allWallets.filter(({ mediaType }) =>
            category === 'energy' ? mediaType === MediaType.ENERGY : mediaType === MediaType.GAS
          );

    setFilteredWallets(filteredByCategory);
  }, [data, withArchive, category]);

  return (
    <GlobalLoader isLoading={isLoading} isError={isError}>
      <div className={styles.container}>
        <div className={styles.walletGrid}>
          {filteredWallets.map(
            ({
              id,
              mediaType,
              description,
              year,
              agreement,
              annualPurchaseRealization,
            }) => (
              <div key={id} className={styles.walletCardContainer}>
                <WalletCard
                  id={id}
                  mediaType={mediaType}
                  description={description || ''}
                  year={year}
                  supplierName={agreement?.supplier?.name || 'Nieznany dostawca'}
                  percentageRealizationProgress={annualPurchaseRealization}
                  agreementStartDate={agreement?.startDate}
                  agreementEndDate={agreement?.endDate}
                />
              </div>
            )
          )}
        </div>
        <div className={styles.smallText}>
          {filteredWallets.length === 0 && <p>Brak zakupów</p>}
        </div>
      </div>
    </GlobalLoader>
  );
};

export default WalletDashboard;
